<script setup lang="ts">
import {router} from "@inertiajs/vue3";

interface Props {
  title: string
  icon: string
  url?: string
}

const props = defineProps<Props>()
</script>

<template>
    <v-card
        :flat="true"
        color="grey-lighten-4"
        class="fill-height"
    >
        <v-card-text>
            <span class="font-weight-medium">{{ props.title }}</span>
            <v-icon
                size="small"
                color="black"
                style="float: right;"
            >
                {{ props.icon }}
            </v-icon>
            <slot />
            <div class="mt-3 text-end">
                <a
                    v-if="props.url"
                    class="text-none text-body-2 text-primary hover-underline cursor-pointer"
                    @click.prevent="router.visit(props.url)"
                >
                    Manage
                </a>
            </div>
        </v-card-text>
    </v-card>
</template>

<style scoped>
.hover-underline:hover {
    text-decoration: underline;
}
</style>
